<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion"
    [matTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)"
    [appOverflowTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>

  <div contenido class="contenidoClass">
    <div class="encabezado">
      <mat-icon class="iconoMen" [ngStyle]="{'color':'gray'}" [matMenuTriggerFor]="menu2">more_vert</mat-icon>
      <mat-menu #menu2="matMenu">
        <button (click)="exportar_excel()" class="mat-menu-item" mat-menu-item class="w3-caja-menu">
          <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
          <span> {{'gestion.formulacion.matRiesOport.export'|translate}} </span>
        </button>
      </mat-menu>
    </div>

    <div class="zonaTablas">
      @if (viewTablero) {
        @for(per of diccionarioEst; track per; let i = $index) {
          <app-contenedor-elementos [header]="{title: per.perspectiva.nombre}" style="height: 40vh;">
            <div body class="tabla">
              <table class="tabla-aleema">
                <thead>
                  <tr>
                    <th style="width: 4vw;">
                      # </th>
                    <th style="width: 12vw;">
                      {{'gestion.formulacion.alineamiento.formText1'|translate}} </th>
                    <th>
                      {{ 'gestion.formulacion.alineamiento.formText2' | translate }} </th>
                    <th *appRoles="permisos.CARGA_ARCHIVOS"
                      style="width: 4vw;">
                      <mat-icon matTooltip="{{ 'gestion.formulacion.alineamiento.tooltip1' | translate }}"
                        (click)="open_modal(per.perspectiva)"
                        class="iconoMen colorBotonDeNuevo">add_circle_outline</mat-icon>
                    </th>
                  </tr>
                </thead>
                @for(ele of per.estrategias; track ele; let i = $index) {
                  <tbody>
                    <tr>
                      <td> E{{i+1}} </td>
                      <td style="max-width: 5vw; overflow: hidden;" [matTooltip]="obtObj(ele)"
                        [appOverflowTooltip]="obtObj(ele)">
                        {{obtObj(ele)}}
                      </td>
                      <td style="max-width: 20vw; overflow: hidden;" [matTooltip]="ele.name"
                        [appOverflowTooltip]="ele.name">
                        {{ele.name}}
                      </td>
                      <td *appRoles="permisos.CARGA_ARCHIVOS">
                        <mat-icon class="iconoMen w3-button"
                          matTooltip="{{ 'gestion.formulacion.alineamiento.tooltip2' | translate }}"
                          (click)="open_edit(ele,per.perspectiva)">edit</mat-icon>
                        <mat-icon class="iconoMen w3-button"
                          matTooltip="{{ 'gestion.formulacion.alineamiento.tooltip3' | translate }}"
                          (click)="alertas('eliminar',ele)">delete</mat-icon>
                      </td>
                    </tr>
                  </tbody>
                }
              </table>
            </div>
          </app-contenedor-elementos>
        }
      }@else {
        @for (item of skeleton; track $index) {
          <app-skeleton-table style="height: 39vh;"/>
        }
      }
    </div>
  </div>
</app-esqueleto-tableros>

<app-modal [isOpen]="modal" [cerrar]="false" (close)="closeModal()">
  <div modal-header>
    {{'gestion.formulacion.alineamiento.formText3' | translate}} |
    @for (per of diccionarioEst; track per) {
      @if (per.perspectiva.id === idPers) {
        {{per.perspectiva.nombre}}
      }
    }
  </div>

  <div modal-body>
    <div class="w3-row" [formGroup]="formEst">
      <!-- <div class="w3-rest"> -->
      @if(formEst.hasError('isValid')) {
        <mat-error style="color: red;">
          {{'gestion.formulacion.alineamiento.formText4'|translate}} <strong>
            {{'gestion.formulacion.alineamiento.formText5'|translate}}.</strong>
        </mat-error>
      }
      <div class="form-group">
        <label for="estrategia" class="form-label">
          {{'gestion.formulacion.alineamiento.formText6' | translate}} *
        </label>
        <input type="text" id="estrategia" class="form-input anchosInputsLarge" formControlName="inputName" required
          placeholder="{{'gestion.formulacion.alineamiento.placeHolderEstra' | translate}}"
          [matTooltip]="formEst.controls.inputName.value" [appOverflowTooltip]="formEst.controls.inputName.value">
      </div>

      <div class="form-group">
        <label for="selectObjetivos" class="form-label">
          {{'gestion.formulacion.alineamiento.formText7' | translate}} *
        </label>
        <select id="selectObjetivos" formControlName="selectObjetivos" class="contentSelect anchosInputsLarge" required
          [ngClass]="{'placeholderSelect': formEst.controls['selectObjetivos'].value === 'default'}">
          <option value="default" disabled selected>
            {{'gestion.formulacion.alineamiento.formText8' | translate}}
          </option>
          @for(obj of objetivos; track obj) {
            @if(obj.perspectiveId === idPers) {
              <option value="{{obj.id}}" style="overflow: hidden;"
              [matTooltip]="obj.nombre" [appOverflowTooltip]="obj.nombre">
                {{obj.nombre}} </option>
            }
          }
        </select>
      </div>
      <!-- </div> -->
    </div>

    <div class="linea" style="width: 80%;"></div>

    <div class="w3-row">
      <div class="w3-noventa w3-titulo-contenidomenu titulo-contenidomenu">
        <div class="hijoizquierdaTitle">
          <span class="w3-margin-left-contenido">
            {{'gestion.formulacion.alineamiento.formText9'| translate }}
          </span>
        </div>
      </div>
    </div>

    <div class="w3-row" [formGroup]="formProg">
      <!-- <div class="w3-rest"> -->
      @if(formProg.hasError('isValid')) {
      <mat-error style="color: red;">
        {{'gestion.formulacion.alineamiento.formText4'|translate}} <strong>
          {{'gestion.formulacion.alineamiento.formText5'|translate}}.</strong>
      </mat-error>
      }
      <div class="form-group">
        <label for="proyecto" class="form-label">
          {{'gestion.formulacion.alineamiento.formText10' | translate}} *
        </label>
        <input type="text" id="proyecto" class="form-input anchosInputsLarge" formControlName="inputNamePro" required
          placeholder="{{'gestion.formulacion.alineamiento.placeHolderProy' | translate}}"
          [matTooltip]="formProg.controls.inputNamePro.value" [appOverflowTooltip]="formProg.controls.inputNamePro.value">
      </div>

      <div class="form-group">
        <label for="descripcion" class="form-label">
          {{'gestion.formulacion.alineamiento.formText11' | translate}}
        </label>
        <textarea id="descripcion" class="outline-textarea anchosInputsLarge" formControlName="inputDesc"
          placeholder="{{'gestion.formulacion.alineamiento.placeHolderDesc' | translate}}"
          [matTooltip]="formProg.controls.inputDesc.value" [appOverflowTooltip]="formProg.controls.inputDesc.value"></textarea>
      </div>

      <div class="form-group">
        <label for="lider" class="form-label">
          {{'gestion.formulacion.alineamiento.formText12' | translate}} *
        </label>
        <select id="lider" formControlName="liderSelect" class="contentSelect anchosInputsLarge" required>
          <option value="default" disabled selected>
            {{'gestion.formulacion.alineamiento.formText13' | translate}}
          </option>
          @for(lider of responsable; track lider) {
          <option value="{{lider.id}}"
          [matTooltip]="lider.nombre" [appOverflowTooltip]="lider.nombre">
            {{lider.nombre}} </option>
          }
        </select>
      </div>
      <!-- </div> -->
    </div>
  </div>

  <app-button modal-footer
    [color]="'var(--color-cancel)'"
    [textColor]="'var(--color-text)'"
    [text]="'menu.cancel' | translate"
    (clickB)="closeModal()"
  />
  <app-button modal-footer
    [ngClass]="puede_guardar()"
    [color]="'var(--color-acept)'"
    [textColor]="'var(--color-text)'"
    [text]="'menu.Guardar' | translate"
    (clickB)="alertas('guardar')"
  />
</app-modal>

<app-modal [isOpen]="modal2" [cerrar]="false" (close)="closeModal()">
  <div modal-header>
    {{'gestion.formulacion.alineamiento.formText3' | translate}} |
    @for (per of diccionarioEst; track per) {
      @if (per.perspectiva.id === idPers) {
        <span class="w3-subtituloA"> {{per.perspectiva.nombre}} </span>
      }
    }
  </div>

  <div modal-body>
    <div class="w3-row" [formGroup]="formEst">
      <div class="w3-rest">
        @if(formEst.hasError('isValid')) {
          <mat-error style="margin-left: 10%; color: red;">
            {{'gestion.formulacion.alineamiento.formText4'|translate}} <strong>
              {{'gestion.formulacion.alineamiento.formText5'|translate}}.</strong>
          </mat-error>
        }
        <div class="form-group">
          <label for="estrategiaedit" class="form-label">
            {{'gestion.formulacion.alineamiento.formText6' | translate}} *
          </label>
          <input type="text" id="estrategiaedit" class="form-input anchosInputs" formControlName="inputNameEdit"
            required placeholder="{{'gestion.formulacion.alineamiento.placeHolderEstra' | translate}}"
            [matTooltip]="formEst.controls.inputNameEdit.value" [appOverflowTooltip]="formEst.controls.inputNameEdit.value">
        </div>

        <div class="form-group">
          <label for="selectObjetivosEdit" class="form-label">
            {{'gestion.formulacion.alineamiento.formText7' | translate}} *
          </label>
          <select id="selectObjetivosEdit" formControlName="selectObjetivos" class="contentSelect anchosInputsLarge"
            required>
            <option value="default" disabled>
              {{'gestion.formulacion.alineamiento.formText8' | translate}}
            </option>
            @for(obj of objetivos; track obj) {
              @if(obj.perspectiveId === idPers) {
                <option [value]="obj.id" style="overflow: hidden;"
                [matTooltip]="obj.nombre" [appOverflowTooltip]="obj.nombre">
                  {{obj.nombre}} </option>
              }
            }
          </select>
        </div>
      </div>
    </div>

    <div class="linea" style="width: 80%;"></div>


    <div class="w3-row">
      <div class="w3-noventa w3-titulo-contenidomenu titulo-contenidomenu">
        <div class="hijoizquierdaTitle">
          <span class="w3-margin-left-contenido">
            {{'gestion.formulacion.alineamiento.formText9'| translate }}
          </span>
        </div>
      </div>
    </div>


    <div class="w3-row" [formGroup]="formProg">
      <div class="w3-rest">
        @if(formProg.hasError('isValid')) {
          <mat-error style="margin-left: 10%; color: red;">
            {{'gestion.formulacion.alineamiento.formText4'|translate}} <strong>
              {{'gestion.formulacion.alineamiento.formText5'|translate}}.</strong>
          </mat-error>
        }
        <div class="form-group">
          <label for="proyectoedit" class="form-label">
            {{'gestion.formulacion.alineamiento.formText10' | translate}} *
          </label>
          <input type="text" id="proyectoedit" class="form-input anchosInputsLarge" formControlName="inputNameProEdit"
            required placeholder="{{'gestion.formulacion.alineamiento.placeHolderProy' | translate}}"
            [matTooltip]="formProg.controls.inputNameProEdit.value" [appOverflowTooltip]="formProg.controls.inputNameProEdit.value">
        </div>

        <div class="form-group">
          <label for="descripcionedit" class="form-label">
            {{'gestion.formulacion.alineamiento.formText11' | translate}}
          </label>
          <textarea id="descripcionedit" class="outline-textarea anchosInputsLarge" formControlName="inputDesc"
            placeholder="{{'gestion.formulacion.alineamiento.placeHolderDesc' | translate}}"
            [matTooltip]="formProg.controls.inputDesc.value" [appOverflowTooltip]="formProg.controls.inputDesc.value"></textarea>
        </div>

        <div class="form-group">
          <label for="lideredit" class="form-label">
            {{'gestion.formulacion.alineamiento.formText12' | translate}} *
          </label>
          <select id="lideredit" formControlName="liderSelect" class="contentSelect anchosInputsLarge" required>
            <option value="default" disabled>
              {{'gestion.formulacion.alineamiento.formText13' | translate}}
            </option>
            @for(lider of responsable; track lider) {
            <option [value]="lider.id"
            [matTooltip]="lider.nombre" [appOverflowTooltip]="lider.nombre">
              {{lider.nombre}} </option>
            }
          </select>
        </div>
      </div>
    </div>
  </div>

  <app-button modal-footer
    [color]="'var(--color-cancel)'"
    [textColor]="'var(--color-text)'"
    [text]="'menu.cancel' | translate"
    (clickB)="closeModal()"
  />
  <app-button modal-footer
    [ngClass]="puede_guardarEdit()"
    [color]="'var(--color-acept)'"
    [textColor]="'var(--color-text)'"
    [text]="'menu.Guardar' | translate"
    (clickB)="alertas('editar')"
  />
</app-modal>